export const PATHS = {
  HOME: "/",
  REGPAGE: "/business-registration",
  POLICY: "/privacy-policy",
  TERMS: "/terms-condition",
  BTERMS: "/business-registration-terms",
};
